<template>
    <div>
        <span style="font-size: x-large">溜溜快洗后台管理</span><br><br>
        <span> 欢迎使用！</span>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
          return {
          }
        },
    }
</script>

<style scoped>

</style>
